import React, { Component } from 'react'
import {
  ImageBlock,
  Block,
  TextBox,
  Header,
  Body,
  Subtitle,
  List,
  ListItem,
  StyledLink
} from './styles'

import theme from '../../theme'
import harp from '../../assets/DSCF4864cropped.jpeg'

import SideBar from '../../components/SideBar'
import MusicCarousel from './components/MusicCarousel'

class Music extends Component {
  links = {
    main: [
      {
        title: 'Music',
        links: [
          { link: '#about', title: 'About' },
          {
            link: '#media',
            title: 'Media'
          }
        ]
      }
    ],
    other: [
      {
        title: 'CS',
        links: [
          { link: '/cs#about', title: 'About' },
          {
            link: '/cs#projects',
            title: 'Projects'
          }
        ]
      }
    ]
  }

  render() {
    return (
      <SideBar links={this.links}>
        <ImageBlock color={theme.colors.palePurple} id="about" img={harp}>
          {/* <Photo
            src={harp}
            alt=""
            min-height="200px"
            min-width="200px"
            height="250px"
          /> */}
          <TextBox color={theme.colors.translucentWhite}>
            <Header color={theme.colors.palePurple}>About Me</Header>
            <Body color={theme.colors.palePurple}>
              I studied harp performance with Jessica Zhou and received my M.M.
              in harp performance through the 5-year Harvard/NEC dual-degree
              program. I was introduced to music through piano lessons with
              Robelyn Schrade-James when I was in Kindergarten, and I began to
              study the harp with Karen Lindquist in third grade. I travel
              around the country to perform and teach as the American Harp
              Society{`'`}s Concert Artist.
              <Subtitle>Music Activities</Subtitle>
              <List>
                <ListItem>
                  First Prize and 2021-2023 Concert Artist, American Harp
                  Society National Competition, Young Professional Division
                  (2021) (
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://www.harpsociety.org/concert-art-program"
                  >
                    Concert Artist page
                  </StyledLink>
                  {', '}
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://harpcolumn.com/blog/american-harp-society-names-new-concert-artist/"
                  >
                    Harp Column article
                  </StyledLink>) (2021-2023)
                </ListItem>
                <ListItem>
                  Harpist, {`"Musae"`} Board Member, and Webmaster of the{' '}
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://www.harvardradcliffeorchestra.org/"
                  >
                    Harvard-Radcliffe Orchestra
                  </StyledLink>{' '}
                  (2016-2020)
                </ListItem>
                <ListItem>
                  Public Service Announcements Director and DJ on 95.3FM as part
                  of the Classical department of{' '}
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://www.whrb.org/"
                  >
                    WHRB
                  </StyledLink>{' '}
                  (2016-2020)
                </ListItem>
                <ListItem>
                  Member of the{' '}
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://www.signetsociety.org/"
                  >
                    Signet Society
                  </StyledLink>{' '}
                  (2019-2020)
                </ListItem>
                <ListItem>
                  Anne Adams Awards Semifinalist (Summer 2018)
                </ListItem>
                <ListItem>
                  Harpist in the{' '}
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://www.carnegiehall.org/Education/Young-Musicians/NYO-USA"
                  >
                    National Youth Orchestra
                  </StyledLink>{' '}
                  (Summer 2016)
                </ListItem>
                <ListItem>
                  <StyledLink
                    color={theme.colors.palePurple}
                    hoverColor={theme.colors.purple}
                    href="https://www.youngarts.org/"
                  >
                    National YoungArts Foundation
                  </StyledLink>{' '}
                  Honorable Mention Winner (2016)
                </ListItem>
                <ListItem>
                  First Prize, American Harp Society National Competition,
                  Intermediate II Division (2015)
                </ListItem>
                <ListItem>
                  First Prize, Young Artist’s Harp Competition, Emerging Artist
                  Division (2014)
                </ListItem>
              </List>
            </Body>
          </TextBox>
        </ImageBlock>
        <Block alignItems="center" color={theme.colors.white} id="media">
          <Header color={theme.colors.palePurple}>Music</Header>
          <MusicCarousel />
        </Block>
      </SideBar>
    )
  }
}

export default Music



// WEBPACK FOOTER //
// ./src/containers/Music/index.js